import { NavLink } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { articles } from '../data/article1';

export default function Article01() {
  return (
    <>
      <Navigation />
      <div className='lecture-article'>
        <NavLink to='/articles' className='retour'>
          <div className='retour__icon--down-arrow'>
            <img src='/icons/left-arrow.svg' alt='icone dun chevron' />
          </div>
          <p className='retour__text'>Retour aux articles</p>
        </NavLink>

        <h2 className='lecture-article__title heading-section color-black u-margin-top-medium '>
          Les Thrulkhors &#x2D; Qu&apos;est ce que c&apos;est ?
        </h2>
        <p className='lecture-article__sous-titre '>Lecture de 10 min | 17/02/2025</p>
        <img src={articles[0].src} alt='article 1' className='lecture-article__img ' />

        <p className='lecture-article__text u-justify-text'>
          Parmi la myriade de techniques issues du bouddhisme tibétain, les Thrulkhors demeurent
          encore peu connus en Occident.{' '}
          <b>
            Ce yoga tibétain est un entraînement du corps, du souffle-énergie et de l&apos;esprit
            {''}
          </b>
          . Le pratiquant unit son esprit à la respiration lors de l&apos;inspiration, retient son
          souffle, réalise certains mouvements visant à faciliter la circulation du souffle-énergie
          dans l&apos;ensemble du corps, et lorsqu&apos;il expire, dépose son esprit dans la
          contemplation. <br />
          Pour utiliser correctement cet outil, il convient de comprendre la tradition à laquelle il
          se rattache et d&apos;en intégrer les éléments fondamentaux. Cette étude préliminaire vise
          à orienter la pratique dans la direction juste. Une approche purement posturale, sans
          compréhension du système traditionnel auquel elle appartient, transformerait cette
          technique en une simple gymnastique. Certes, vous en tireriez certains bénéfices, mais
          vous passeriez à côté de l&apos;essentiel : la contemplation, état de la pleine présence
          de la conscience à elle-même. <br />À titre d&apos;exemple, cela s&apos;apparenterait à
          monter dans un véhicule puissant et flambant neuf sans savoir le conduire et sans carte
          pour s&apos;orienter. Même si vous réussissiez à trouver la clé et à démarrer le moteur,
          au mieux, vous tourneriez en rond sans direction, et au pire des cas, vous risqueriez
          l&apos;accident.
        </p>

        <h2 className=' heading-infos color-black u-margin-top-medium'>
          Les Thrulkhors dans leur contexte traditionnel bouddhiste et bön
        </h2>
        <p className='lecture-article__text'>
          Les Thrulkhors sont issus du bouddhisme tibétain, notamment des écoles nyingma et kagyu,
          mais on les retrouve également chez les bönpos. Ces derniers en font remonter
          l&apos;origine à leur fondateur Tonpa Shenrab. Cette pratique se serait transmise
          jusqu&apos;à nos jours par des lignées ininterrompues de pratiquants accomplis. <br />
          Le Bouddhisme s&apos;enseigne selon trois cycles successifs :
        </p>
        <ul className='u-margin-left list-article lecture-article__text'>
          <li className='list-article '>
            {' '}
            les <b>Sûtras</b> ou la voie du renoncement,
          </li>
          <li className='list-article'>
            {' '}
            les <b>Tantras</b> ou la voie de la transformation
          </li>
          <li className='list-article'>
            et le plus élevé, le <b>Dzogchen</b> ou voie de l&apos;auto-libération
          </li>
        </ul>
        <p className='lecture-article__text'>
          Les Thrulkhors font partie des pratiques préliminaires de cette dernière voie. Le Dzogchen
          offre la possibilité de s&apos;éveiller en cette vie même, en reconnaissant directement la
          nature de l&apos;esprit, au-delà de toutes les formes et représentations liées à des
          contextes culturels et religieux, puis en stabilisant cette reconnaissance à chaque
          instant. Cet acte de reconnaissance est en soi simple, mais l'esprit ordinaire, trop
          confus, passe souvent à côté. La nature de l&apos;esprit est ce qu&apos;elle est, ni plus
          ni moins, et rien ne peut la diminuer ni l&apos;augmenter.
        </p>
        <p className='lecture-article__text'>
          Les obstacles mentaux et émotionnels empêchent cette reconnaissance, à la manière dont les
          nuages voilent le ciel. Loin des pratiques de développement personnel,{' '}
          <b>les Thrulkhors ne développent rien, mais dissipent ces obstacles</b>. Les Thrulkhors
          font partie de ce que la tradition appelle les « moyens habiles » : utilisés avec
          habileté,{' '}
          <b>
            ils permettent à la reconnaissance de la nature de l'esprit d&apos;advenir et de se
            stabiliser
          </b>
          . De plus, en dissipant les blocages physico-énergétiques, les Thrulkhors contribuent à un
          équilibre interne propice au maintien de la santé et à une longue vie.
        </p>

        <NavLink
          to='/stages-et-retraites/stage-2'
          className='btn stage__btn btn--white u-center-text u-center-element u-margin-top-medium'
        >
          Participer à un stage
        </NavLink>

        <h2 className=' heading-infos color-black u-margin-top-medium'>Sources</h2>

        <ul className='u-margin-left lecture-article__text'>
          <li>
            <b>Lama Dukte, Tempa</b>. Thrul Kor Ancient Tibetan Bon Yoga. Olmo Ling Publications,
            2019. 260 pages.
          </li>
          <li>
            <b>Chaoul, Alejandro</b>. Le yoga tibétain au quotidien. Éditions Médicis, 2021. 118
            pages.
          </li>
        </ul>
      </div>
    </>
  );
}
